import { render, staticRenderFns } from "./MatchingSearch.vue?vue&type=template&id=23265744&"
import script from "./MatchingSearch.vue?vue&type=script&lang=js&"
export * from "./MatchingSearch.vue?vue&type=script&lang=js&"
import style0 from "./MatchingSearch.vue?vue&type=style&index=0&id=23265744&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports